import * as React from "react";
import PropTypes from "prop-types";
import { LoadingIndicator as PLLoadingIndicator } from "@lululemon/ui-library";
import InlineError from "../inline-error/index";
import styles from "./loading-indicator.module.scss";

const LoadingIndicator = ({
  direction = "center",
  show,
  translations,
  onTimeout = () => {}
}) => {
  const [error, setError] = React.useState(null);

  React.useEffect(() => {
    const timeout = setTimeout(() => {
      if (show) {
        setError({
          title: translations.messages.timeout.title,
          msg: translations.messages.timeout.msg
        });
        try {
          onTimeout?.();
        } catch (error) {
          console.log("timeout error", { error });
        }
      }
    }, 30000);

    return () => clearTimeout(timeout);
  }, [show, translations, onTimeout]);

  if (!show) return null;

  return error ? (
    <InlineError title={error.title} msg={error.msg} />
  ) : (
    <div className={styles.loadingIndicator}>
      <div className={styles[direction]}>
        <PLLoadingIndicator />
      </div>
    </div>
  );
};

LoadingIndicator.propTypes = {
  direction: PropTypes.string,
  show: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
  onTimeout: PropTypes.func,
  translations: PropTypes.shape({
    messages: PropTypes.shape({
      timeout: PropTypes.shape({
        msg: PropTypes.string,
        title: PropTypes.string
      })
    })
  }).isRequired
};

export default LoadingIndicator;
